import { onUnmounted, onMounted, unref } from 'vue';

/**
 *
 * @param {HTMLElement[] | HTMLElement} elMaybeRefs
 * @param {void} cb
 */
export const useClickOutside = (elMaybeRefs, cb) => {
    const onClick = (e) => {
        const els = Array.isArray(elMaybeRefs) ? elMaybeRefs.map((elMaybeRef) => unref(elMaybeRef)) : [unref(elMaybeRefs)];

        if (!els.every((el) => el instanceof HTMLElement) || typeof cb !== 'function') return;

        if (!els.some((el) => el.contains(e.target))) cb();
    };

    onMounted(() => {
        window.addEventListener('click', onClick, { passive: true });
    });

    onUnmounted(() => {
        window.removeEventListener('click', onClick, { passive: true });
    });
};
